module.exports = __webpack_public_path__ + "img/footer-logo.bf2ab183.svg";